import * as Sentry from "@sentry/react-native";

const isStage = window.location.hostname === "app.axiostage.xyz" || window.location.hostname === "fun.axiostage.xyz";

const isDev = window.location.hostname === "axiodev.xyz";

const isProd = !isDev && !isStage;

export const routingInstrumentation = Sentry.reactNavigationIntegration();

Sentry.init({
  dsn: "https://b41d994af645ceb351dc6ae3942f4968@o4507644674834432.ingest.us.sentry.io/4507914951917568",
  enableTimeToInitialDisplay: true,
  integrations: [routingInstrumentation],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  environment: isProd ? "production" : isStage ? "stage" : "development",
  enabled: isProd || isStage,
  ignoreErrors: ["User not found", "Tenant not found"],
});

export default Sentry;
